<template>
  <div class="MarketInfoEdit pt5" v-title data-title="行情价格">
    <van-tabs
      v-model="quoteType"
      :offset-top="0"
      sticky
      type="card"
      color="#1e67c7"
      @click="changeQuoteType"
    >
      <van-tab  v-for="quoteType in quoteTypes" :key="quoteType.value" :title="quoteType.text" :name="quoteType.value"></van-tab>
    </van-tabs>
    <div class="row align-items-center pb5 pt7 pr5">
      <span class="form-item-label pr5">行情类型</span>
      <select class="flex-1" v-model="detailInfo.typeId" @change="changeMaketType">
        <option value="">请选择</option>
        <option v-for="ps in options.types" :value ="ps.id" :key="ps.id">
          {{ps.typeName}}
        </option>
      </select>
      <!-- <div class="add-box bc-default pl7 pr7">
        <div v-if="!selectedUnits.text" class="fc-danger pt5 pb5">请先选择重量单位</div>
        <div class="add bc-white fc-primary" @click="changeUnit()">
          {{selectedUnits.value?'点击切换':'点击选择'}}重量单位{{selectedUnits.text?'(当前选择：'+selectedUnits.text+')':''}}
        </div>
      </div> -->
      <!-- <van-button type="info" plain roundsize="small">调整报价顺序</van-button> -->
    </div>
    <template v-if="quoteType == 2">
      <template v-if="detailInfo.typeId">
        <QuotationEditComponent
          ref="QuotationEditComponent"
          from="market"
          :quoteType="quoteType"
          :lastData="lastData"
          :typeId="detailInfo.typeId"
        />
      </template>
    </template>
    <template v-else>
      <div class="row align-items-center pb5 pr5">
        <span class="form-item-label pr5">重量单位</span>
        <select class="flex-1" v-model="detailInfo.specUnit" @change="changeUnit()">
          <option value="">请选择</option>
          <option v-for="ps in options.units" :value ="ps.value" :key="ps.value">
            {{ps.text}}
          </option>
        </select>
        <div class="flex-1"></div>
        <van-button @click="showPopup" type="info" plain roundsize="small">调整报价顺序</van-button>
      </div>
      <!-- <div v-if="!detailInfo.typeId" class="fc-danger pt5 pb5">请先选择库虾公司再进行报价</div> -->
      <table class="table-marketinfo">
        <thead>
          <tr>
            <th>地区</th>
            <template v-for="(ct) in categories">
              <th width="130px" :key="ct.id">
                  <!-- {{ct.id}} -->
                  <template v-if="options.categories && options.categories.length && ((!ct.jargonCode &&  ct.jargonCode !== '') || (options.categories.find(item => item.value == ct.jargonCode)))">
                    <select v-model="ct.jargonCode" class="market-select">
                      <option :value="null">请选择行话</option>
                      <option v-for="ps in options.categories" :value ="ps.value" :key="ps.value">
                        {{ps.text}}
                      </option>
                      <option value="">自定义行话</option>
                    </select>
                  </template>
                  <template v-else>
                    <input v-model="ct.jargonCode" class="market-input" placeholder="自定义行话"/>
                  </template>

                  <template v-if="options.weight && options.weight.length && ((!ct.weight &&  ct.weight !== '') || (options.weight.find(item => item.value == ct.weight)))">
                    <select v-model="ct.weight" class="market-select">
                      <option :value="null">请选择规格</option>
                      <option v-for="ps in options.weight" :value ="ps.value" :key="ps.value">
                        {{ps.text}}
                      </option>
                      <option value="">自定义规格</option>
                    </select>
                  </template>
                  <template v-else>
                    <input v-model="ct.weight" class="market-input" placeholder="自定义规格"/>
                  </template>

                  <span class="fc-danger fs1" @click="cancelCol(ct)">取消</span>
                  <!-- <van-icon name="delete" class="fc-danger fs1" @click="cancelCol(ctindex)"/> -->
              </th>
            </template>
            <th width="50px">操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(info, infoIndex) in infoList" :key="info.id">
            <td>
              <!-- {{info.id}} -->
              <select v-model="info.regionCode" @change="changeCate(info)" class="w100p">
                <option value="">请选择</option>
                <option v-for="sc in options.regions" :value ="sc.code" :key="sc.code">
                  {{sc.name}}
                </option>
              </select>
            </td>
            <!-- 价格信息区域 -->
            <template v-for="(pr, prIndex) in prices[info.id]">
              <td width="130px" :key="pr.id+'price'">
                <div class="row align-items-center">
                  <van-field
                    v-model="pr.price1"
                    type="number"
                    placeholder="价格"
                    style="width: 55px;"
                    @change="changePrice(pr, infoIndex)"
                  />
                  -
                  <van-field
                    v-model="pr.price2"
                    type="number"
                    placeholder="价格"
                    style="width: 55px;"
                    @change="changePrice(pr, infoIndex)"
                  />
                </div>
              </td>
            </template>
            <td><a @click="cancelRow(info)" class="fc-danger fs4">取消</a></td>
          </tr>
          <tr>
            <td colspan="3">
              <van-button @click="addCol" plain class="btn-success" type="info" :style="{marginRight: '5px'}"><van-icon name="plus"/> 增加一列</van-button>
              <van-button @click="addRow" plain class="btn-common" type="info" :style="{marginLeft: '5px'}"><van-icon name="plus"/> 增加一行</van-button>
            </td>
          </tr>
        </tbody>
      </table>
      <van-popup
        v-model="popupShow"
        position="bottom"
        :style="{ height: '100%' }"
      >
        <h4>调整报价顺序</h4>
        <div class="pl5 pb7 pr5">
          <div class="sort-box">
            <template v-for="(info, popupDataIndex) in popupDataList" >
              <div class="row align-items-center pt3 pb3 pl5 pr5" :key="popupDataIndex">
                <div class="flex-1 text-left">{{marketCategoryMapping[info.regionCode].name}}</div>
                <div class="col-6"><van-button v-if="popupDataIndex>0" @click="goUp(popupDataIndex)" type="info" plain size="small" class="pl5">点我向上&#x2b06;</van-button></div>
                <div class="col-6"><van-button v-if="popupDataIndex+1<popupDataList.length" @click="goDown(popupDataIndex)" type="info" plain size="small" class="pl5">点我向下&#x2b07;</van-button></div>
              </div>
              <div class="line" :key="'line'+popupDataIndex"></div>
            </template>
          </div>
          <div class="row justify-content-around mt10">
            <van-button @click="closePopup" type="info" class="btn-common" plain>暂不调整</van-button>
            <van-button @click="saveSort" type="info" class="btn-common">保存顺序</van-button>
          </div>
        </div>
      </van-popup>

    </template>

    <div class="mt5">
      <div class="required-box">发布时间</div>
      <van-field
        @click="showTime()"
        v-model="detailInfo.publishTime"
        readonly
        class="flex-1"
        placeholder="请选择发布时间"
      />
      <!-- <div class="row align-items-center mt3">
        <div class="required-box">备注</div>
        <van-field
          v-model="detailInfo.remark"
          class="flex-1"
          rows="2"
          autosize
          type="textarea"
          placeholder="请输入备注"
        />
      </div> -->
    </div>
    <van-popup v-model="timeShow"
      position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="datetime"
        title="选择日期"
        @confirm="confirmTime"
        @cancel="timeShow=false"
      />
    </van-popup>

    <div class="row justify-content-around mt10">
      <van-button @click="back" type="info" class="btn-common" plain>返回</van-button>
      <van-button @click="publish" type="info" class="btn-common">发布价格</van-button>
    </div>
    <!-- <van-popup v-model="showUnitPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="options.units"
        @cancel="showUnitPicker = false"
        @confirm="onConfirmUnit"
      />
    </van-popup> -->
  </div>
</template>

<script>
import Vue from 'vue';
import QuotationEditComponent from '@/components/QuotationEditComponent.vue';
import { QUOTE_TYPE_MAPPING, QUOTE_SECTION } from '@/uitls/const';
import {
  sendRequest, getMarketPriceOptions, publishMarketPrice, publishCrabMarketPrice, getLastMarketPrice, quoteDict, getMarketVarieties,
} from '@/network/NetworkAccessor';
import storage from '@/uitls/cacheUtil';

const typeObj = {
  id: +new Date(), title: '行话', jargonCode: null, weight: null,
};
const priceObj = {
  id: +new Date(),
  regionCode: '',
};
let marketDicts = {};
export default Vue.extend({
  name: 'MarketInfoEdit',
  components: {
    QuotationEditComponent,
  },
  data() {
    return {
      // 普货、普挑、精挑、挑膏
      sectionMapping: QUOTE_SECTION,
      loading: false,
      quoteTypes: [],
      quoteType: '',
      infoList: [],
      detailInfo: {
        typeId: '',
        weight: null,
        specUnit: '',
      },
      prices: {},
      options: {},
      categories: [],
      popupShow: false,
      popupDataList: [],
      timeShow: false,
      currentDate: new Date(),
      show: true,
      marketCategoryMapping: {},
      showUnitPicker: false,
      lastData: {},
    };
  },
  methods: {
    changePrice(item, index) {
      // 管理员后台-行情后台-行情价格-龙虾价格，价格编辑区域新增优化功能。因为管理员编辑的各地价格大部分相同，所以想偷懒
      // 1、新增价格：每个区域价格看该区域的第一行，如当第一行填的是4-5，这一列默认为4-5，不用重新再填写，这一列下面如果有不一样，人工会来修改
      // 2、修改价格：每个区域价格看该区域的第一行，如当第一行填的是4-5，修改为5-6，这一列下面调整为5-6，不用重新再填写，这一列下面如果有不一样，人工会来修改
      if (this.quoteType == '1' && index === 0) {
        // console.log('changePrice: ', item, this.prices, this.categories);
        // 将第二行开始的当前列的价格修改为第一行当前列的价格
        const prices = {};
        Object.entries(this.prices).forEach(([regionId, list]) => {
          prices[regionId] = list.map((pr) => {
            if (pr.id === item.id) {
              return {
                ...pr,
                price1: item.price1,
                price2: item.price2,
              };
            }
            return pr;
          });
        });
        this.prices = prices;
      }
    },
    quotesAdd() {
      // console.log('this.$refs：', this.$refs);
      if (this.$refs && this.$refs.QuotationEditComponent) {
        const params = this.$refs.QuotationEditComponent.publish();
        console.log('------------params: ', params);
        const { typeId, publishTime } = this.detailInfo;
        const paramsList = params.map((paramsItem) => {
          const {
            quoteType: variety, unitCode: specUnit, records = [], section,
          } = paramsItem || {};
          return {
            variety,
            typeId,
            publishTime,
            specUnit,
            section: section || undefined,
            quotationContent: JSON.stringify({
              specUnit,
              priceInfo: records.map(item => ({
                price: item.price,
                specCode: item.weightCode || item.weightcode,
                jargonCode: item.categoryCode || item.categorycode,
              })),
            }),
          };
        });
        this.saveInfo(paramsList);
      }
    },
    getMarketVarieties() {
      return sendRequest(getMarketVarieties, {}).then((res) => {
        this.quoteTypes = res || [];
        this.quoteType = this.quoteTypes[0].value;
        this.changeQuoteType(this.quoteType);
      });
    },
    changeQuoteType(val) {
      this.options = {
        ...marketDicts[QUOTE_TYPE_MAPPING[val].dictCode],
        priceType: marketDicts.priceType,
      };
      this.$set(this.detailInfo, 'typeId', '');
      this.getMarketTypes();
    },

    changeUnit(init) {
      this.$set(this.options, 'weight', (this.options.units.find(v => v.value === this.detailInfo.specUnit) || {}).sub || []);
      if (!init) {
        this.categories = this.categories.map(v => ({
          ...v,
          weight: null,
        }));
      }
    },
    getDict(specUnit) {
      // console.log(this.units);
      return sendRequest(quoteDict).then((res = {}) => {
        marketDicts = res || {};
      }).catch((e) => {
        console.error(e);
      });
    },
    changeCate(item = {}) {
      // eslint-disable-next-line eqeqeq
      const list = this.infoList.filter(c => c.regionCode == item.regionCode);
      // eslint-disable-next-line eqeqeq
      const find = this.options.regions.find(sc => sc.code == item.regionCode);

      if (list.length > 1) {
        this.$set(item, 'regionCode', '');
        this.$dialog.alert({
          message: `${find.name}已存在，不可以重复添加，请重新选择`,
        });
      }
    },
    changeMaketType() {
      this.getLastInfo();
    },
    showTime() {
      this.timeShow = true;
    },
    confirmTime(val) {
      this.$set(this.detailInfo, 'publishTime', this.formatDate(val));
      this.timeShow = false;
    },
    addRow() {
      // console.log('addRow ', ' categories: ', this.categories);
      // console.log('addRow ', ' infoList: ', this.infoList);
      // console.log('addRow ', ' prices: ', this.prices);
      // 新增一行时 第二行开始价格需要复制第一行的价格
      // 找到第一行的价格
      const [firstLineItem] = this.infoList;
      const firstLinePrices = (this.quoteType == '1' && firstLineItem) ? this.prices[firstLineItem.id] : [];
      const id = +new Date();
      this.infoList.push({ ...priceObj, id });
      const list = this.categories.map((cat, catIndex) => {
        const { price1 = '', price2 = '' } = firstLinePrices[catIndex] || {};
        return {
          ...cat,
          price1,
          price2,
        };
      });
      this.$set(this.prices, id, list);
      // 新增一行时 第二行开始价格需要复制第一行的价格
    },
    cancelRow({ id }) {
      const infoIndex = this.infoList.findIndex(item => item.id === id);
      this.infoList.splice(infoIndex, 1);
      if (this.infoList.length < 1) {
        // this.infoList = [{ ...priceObj }];
        this.addRow();
      }
    },
    addCol() {
      const id = +new Date();
      this.categories.push({
        ...typeObj,
        id,
      });
      Object.entries(this.prices).forEach(([regionId, list]) => {
        list.push({
          id,
          price1: '',
          price2: '',
        });
        this.$set(this.prices, regionId, list);
      });
      // console.log('addCol-prices----', prices);
      // this.prices = prices;
    },
    cancelCol({ id }) {
      const infoIndex = this.categories.findIndex(item => item.id === id);
      this.categories.splice(infoIndex, 1);
      if (this.categories.length < 1) {
        // this.categories = [{ ...typeObj }];
        this.addCol();
      }
      Object.entries(this.prices).forEach(([regionId, list]) => {
        this.$set(this.prices, regionId, list.filter(pr => pr.id !== id));
      });
    },
    getMarketTypes() {
      sendRequest(getMarketPriceOptions, {
        variety: this.quoteType || 1,
      }).then((res = {}) => {
        const { types = [], regions = [] } = res || {};
        this.$set(this.options, 'types', types);
        this.$set(this.options, 'regions', regions);
        this.$set(this.detailInfo, 'typeId', (types[0] || {}).id);
        this.changeMaketType();

        // this.options = {
        //   ...this.options,
        //   ...res,
        // };
        // if (res && res.types && res.types.length) {
        //   const tid = this.options.types[0].id;
        //   this.$set(this.detailInfo, 'typeId', tid);
        //   this.getLastInfo();
        // }
        const marketCategoryMapping = {};
        regions.forEach((sc) => {
          marketCategoryMapping[sc.code] = sc;
        });
        this.marketCategoryMapping = marketCategoryMapping;
      }).catch((e) => {
        console.error(e.message);
        this.$dialog.alert({
          message: `${e.message}`,
        });
      });
    },
    formatDate(date) {
      if (!date) {
        return '';
      }
      const month = date.getMonth() + 1;
      const monthStr = month > 9 ? month : `0${month}`;
      const d = date.getDate();
      const dStr = d > 9 ? d : `0${d}`;
      const h = date.getHours();
      const hStr = date.getHours() > 9 ? h : `0${h}`;
      const m = date.getMinutes();
      const mStr = date.getMinutes() > 9 ? m : `0${m}`;
      const datestr = `${date.getFullYear()}-${monthStr}-${dStr} ${hStr}:${mStr}:00`;
      return datestr;
    },
    publish() {
      const { typeId, publishTime, specUnit } = this.detailInfo;
      if (!typeId) {
        this.$dialog.alert({
          message: '请选择行情类型',
        });
        return;
      }
      if (!publishTime) {
        this.$dialog.alert({
          message: '请选择发布时间',
        });
        return;
      }
      if (this.$refs && this.$refs.QuotationEditComponent) {
        this.quotesAdd();
        return;
      }
      if (!specUnit) {
        this.$dialog.alert({
          message: '请选择单位',
        });
        return;
      }
      const failed = this.infoList.some((il) => {
        // 价格（每个行话至少填1个价格）
        const flag = this.prices[il.id] && this.prices[il.id].some(pr => !pr.price1 && !pr.price2);
        // 行话必填
        const hflag = this.categories.some(cat => !cat.jargonCode);
        // 规格必填
        const gflag = this.categories.some(cat => !cat.weight);
        return !il.regionCode || flag || hflag || gflag;
      });
      if (failed) {
        this.$dialog.alert({
          message: '请将地区、行话、规格、价格信息填写完整后再进行发布',
        });
        return;
      }
      const jargonCode = this.categories.map(cat => cat.jargonCode);
      const specCode = this.categories.map(cat => cat.weight);
      const priceInfo = this.infoList.map((pr) => {
        const prlist = this.prices[pr.id].map((item) => {
          const { price1, price2 } = item;
          return `${price1 || ''}${(price1 || price2) ? '-' : ''}${price2 || ''}`;
        });
        return {
          regionCode: pr.regionCode,
          price: prlist,
        };
      });
      const params = {
        ...this.detailInfo,
        quotationContent: JSON.stringify({
          jargonCode,
          priceInfo,
          specUnit,
          specCode,
        }),
        variety: this.quoteType,
      };
      this.saveInfo([params]);
    },
    saveInfo(params) {
      // 螃蟹报价走单独接口
      let pros = [];
      if (this.quoteType == '2') {
        const pro = sendRequest(publishCrabMarketPrice, params).catch((e) => {
          console.error(e);
          // this.$dialog.alert({
          //   message: '发布报价失败',
          // });
          throw new Error('发布螃蟹报价失败');
        });
        pros = [pro];
      } else {
        pros = params.map(item => sendRequest(publishMarketPrice, item).catch((e) => {
          console.error(e);
          throw new Error(`发布${this.sectionMapping[item.section] || ''}行情价格失败`);
        }));
      }
      if (!pros.length) {
        this.$dialog.alert({
          message: '请填写行情价格后再发布',
        });
        return;
      }
      Promise.all(pros).then(() => {
        this.$dialog.alert({
          message: '发布行情价格成功',
        });
      }).catch((e) => {
        console.error(e);
        this.$dialog.alert({
          message: e.message,
        });
      });
    },
    showPopup() {
      this.popupShow = true;
      const list = this.infoList.filter(info => info.regionCode);
      this.popupDataList = JSON.parse(JSON.stringify(list));
    },
    closePopup() {
      this.popupShow = false;
    },
    saveSort() {
      this.infoList = JSON.parse(JSON.stringify(this.popupDataList));
      this.closePopup();
    },
    goUp(popupDataIndex) {
      if (!popupDataIndex) {
        return;
      }
      const current = this.popupDataList.splice(popupDataIndex, 1);
      this.popupDataList.splice(popupDataIndex - 1, 0, current[0]);
    },
    goDown(popupDataIndex) {
      if ((!popupDataIndex && popupDataIndex !== 0) || popupDataIndex + 1 >= this.popupDataList.length) {
        return;
      }
      const current = this.popupDataList.splice(popupDataIndex, 1);
      this.popupDataList.splice(popupDataIndex + 1, 0, current[0]);
    },
    back() {
      const type = storage.local.get('type');
      this.$router.push(type === 1 ? '/market/info/home' : '/home');
    },
    getLastInfo() {
      // 螃蟹的报价是和报价商那块一样 会单独处理
      if (this.quoteType == 2) {
        // this.$refs.QuotationEditComponent.getLastData();
        return;
      }
      const { typeId: tid } = this.detailInfo;
      Promise.resolve().then(() => {
        if (!tid) {
          return {};
        }
        // eslint-disable-next-line no-unused-expressions
        return sendRequest(getLastMarketPrice, {
          typeId: tid,
        }).then((res = []) => (res.length ? res[0] : {})).catch((e) => {
          console.error(e.message);
          this.$dialog.alert({
            message: `${e.message}`,
          });
          return {};
        }).then((info) => {
          this.categories = [];
          this.infoList = [];
          this.prices = {};
          const { quotationContent = '{}', publishTime } = info || {};
          const {
            jargonCode = [], priceInfo = [], specCode = [], specUnit = '',
          } = JSON.parse(quotationContent) || {};
          // console.log('上次报价详情：', '行话：', jargonCode, '规格：', specCode, '价格：', priceInfo);
          if (jargonCode.length || priceInfo.length) {
            this.detailInfo = {
              publishTime,
              typeId: tid,
              specUnit,
            };
            if (`${this.quoteType}` === '2') {
              this.lastData = {
                formValues: {
                  ...this.formValues,
                  unitCode: specUnit,
                },
                quoteValues: priceInfo.map(item => ({
                  weightcode: item.specCode,
                  categorycode: item.jargonCode,
                  price: item.price,
                })),
              };
              // console.log('this.lastData：', this.lastData);
              return;
            }
            // 处理每列数据
            const categories = jargonCode.map((cat, catindex) => {
              const id = +new Date() + catindex;
              const weight = specCode[catindex] || '';
              return {
                id,
                jargonCode: cat,
                title: '行话',
                weight,
              };
            });
            // console.log('categories：', categories);
            this.categories = categories;
            // 处理每行数据
            // priceInfo: [{
            //   price: ["1-2", '3-4']
            //   regionCode: "120000"
            // }]
            const prices = {};
            const regions = priceInfo.map(({ price, regionCode }, itemindex) => {
              const rowid = +new Date() + itemindex;
              const prList = price.map((pr, prindex) => {
                const [price1 = '', price2 = ''] = pr.split('-');
                return {
                  id: categories[prindex].id,
                  price1,
                  price2,
                };
              });
              prices[rowid] = prList;
              return {
                id: rowid,
                regionCode,
              };
            });
            this.infoList = regions;
            this.prices = prices;
          } else {
            this.categories = [];
            this.infoList = [];
            this.prices = {};
            this.addRow();
            this.$nextTick(() => {
              this.addCol();
            });
          }
        });
      }).catch((e) => {
        console.error(e.message);
      }).then((res) => {
        this.changeUnit(true);
        if (!this.detailInfo.publishTime) {
          this.confirmTime(new Date());
        }
      });
    },
  },
  created() {
    this.confirmTime(new Date());
    // 获取字典
    this.getDict().then(() => {
      // 获取品类
      this.getMarketVarieties();
    });
    // this.getDict();
    // this.getLastInfo();
  },
});
</script>
<style scoped>
  .MarketInfoEdit {
    min-height: 100vh;
    background-color: #ffffff;
    padding: 15px 5px;
  }
  .MarketInfoEdit .market-select,.market-input{
    width: 130px;
    color: #000000;
  }
  .form-item-label {
    width: 105px;
    text-align: right;
  }
  .required-box {
    width: 70px;
    font-size: 15px;
    text-align: left;
  }
  .MarketInfoEdit select {
    border: 1px solid #a7a9af;
    background-color: #ffffff;
    min-width: 130px;
    font-size: 18px;
    border-radius: 4px;
  }
  .MarketInfoEdit .table-marketinfo {
    width: 100%;
    border-spacing: 0;
    border-radius: 4px;
    border: 1px solid #1e67c7;
    background-color: #ffffff;
    /* border-top: 1px solid #1e67c7;
    border-left: 1px solid #1e67c7;
    border-right: 1px solid #1e67c7; */
  }
  .table-marketinfo th {
    background-color: #1e67c7;
    color: #ffffff;
    padding: 6px 0;
    /* border-bottom: 1px solid #1e67c7; */
  }
  .table-marketinfo td {
    padding: 6px 2px;
    /* border-bottom: 1px solid #1e67c7; */
  }
  .btn {
    width: 80%;
  }
  .btn-add {
    width: 40%;
  }
  .MarketInfoEdit >>> .van-stepper__input {
    font-size: 16px;
  }
  .MarketInfoEdit .market-input {
    padding: 6px 5px;
    border-radius: 4px;
  }
  .MarketInfoEdit a {
    text-decoration: underline;
    cursor: pointer;
  }
  .MarketInfoEdit .line {
    border-top: 1px solid #dcdcdc;
  }
  .sort-box {
    min-height: 300px;
  }
  .MarketInfoEdit button {
    white-space: nowrap;
  }
</style>
